var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineDocumentsRecipe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 34,
    viewBox: "0 0 31 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2675"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 6763 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80217 23.3765L15.5 29.2371L22.1978 23.3765L27.1667 27.8485V3.66634H3.83333V27.8485L8.80217 23.3765ZM2.16667 0.333008H28.8333C29.7538 0.333008 30.5 1.0792 30.5 1.99967V31.5907C30.5 33.0337 28.7909 33.7948 27.7184 32.8296L22.1667 27.833L16.5975 32.706C15.9691 33.2559 15.0309 33.2559 14.4025 32.706L8.83333 27.833L3.28161 32.8296C2.20907 33.7948 0.5 33.0337 0.5 31.5907V1.99967C0.5 1.0792 1.24619 0.333008 2.16667 0.333008Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 15 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16602 8.66699H15.4993V12.0003H7.16602V8.66699Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 17 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16602 15.333H23.8327V18.6663H7.16602V15.333Z",
    fill: "#8F8F8F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineDocumentsRecipe);
export default __webpack_public_path__ + "static/media/Line__Documents--recipe.a9049c7cf260a1f140b566dd13367a9d.svg";
export { ForwardRef as ReactComponent };